export default __webpack_public_path__ + "static/media/step1.e0cf3282.svg";